/**
 * <b>특정 구조를 이룩하는 필요한 메소드를 담는 객체입니다.</b>
 * <pre>
 * 특정 객체의 구조를 변경하거나 조절하기 위해서 사용됩니다.
 * </pre>
 */
class Struct{
    /**
     * <b>this를 바인딩하는 메소드입니다.</b>
     * @param {Object} self - methods을 붙힐 객체
     * @param {Array} methods - 객체에 붙힐 methods
     * @return {Array} methods - 반환된 객체
     */
    tBind(self, methods) {
        let keys = Object.keys(methods);
        for (let i = 0; i < keys.length; i++) {
            methods[keys[i]] = methods[keys[i]].bind(self);
        }
        return methods;
    }

    /**
     * <b>vuex(store)에 mutation을 접두사를 붙히기 위해서 사용하는 메소드입니다.</b>
     * @param {String} name - 붙힐 접두사
     * @param {Array} methods - 붙힐 methods
     * @return {Array} refine_mutations - vuex에 사용될 mutation을 리턴합니다.
     */
    sBind(name, methods) {
        let mutations = methods.mutations;
        let refine_mutations = {};
        for (let atom in mutations) {
            refine_mutations[name + '/' + atom] = mutations[atom];
        }
        return refine_mutations;
    }

    /**
     * <b>vuex(store)에 getters를 접두사를 붙히기 위해서 사용하는 메소드입니다.</b>
     * @param {String} name - 붙힐 접두사
     * @param {Array} methods - 붙힐 methods
     * @return {Array} refine_getters - vuex에 사용될 getters를 리턴합니다.
     */
    sgBind(name,methods){
        let getters = methods.getters;
        let refine_getters = {};
        for (let atom in getters) {
            refine_getters[name + '/' + atom] = getters[atom];
        }
        return refine_getters;
    }

    /**
     * <b>vuex(store)에 action을 접두사를 붙히기 위해서 사용하는 메소드입니다.</b>
     * @param {String} name - 붙힐 접두사
     * @param {Array} methods - 붙힐 methods
     * @return {Array} refine_actions - vuex에 사용될 action을 리턴합니다.
     */
    saBind(name, methods) {
        let actions = methods.actions;
        let refine_actions = {};
        for (let atom in actions) {
            refine_actions[name + '/' + atom] = actions[atom];
        }
        return refine_actions;
    }
}

export default new Struct();